function normalizeUrl(url: string): string {
  const trimmedUrl = url.trim()

  // Check if it already starts with http:// or https://
  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl
  }

  // Regex to check if it looks like a domain or subdomain
  const domainPattern = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/

  if (domainPattern.test(trimmedUrl)) {
    return `http://${trimmedUrl}`
  }

  // Return original if it's not a recognizable domain
  return trimmedUrl
}
export default normalizeUrl
